module.exports = __webpack_public_path__ + "static/media/twitter-container-black.a310177d.svg";